import { ContentTableItem } from "src/components/ContentTable/ContentTable";
import { getContentTypeName } from "./contentTypeNames";

export function mapContentOrdersToContentTableItems(
	allOrders: ContentOrder[]
): ContentTableItem[] {
	const activeOrders = allOrders.filter((s) => s.isPublished);
	const draftOrders = allOrders.filter((s) => !s.isPublished);

	const live = [...activeOrders]
		.sort((a, b) => a.order - b.order || a.id - b.id)
		.map((section, index) => ({
			id: section.id,
			name: getContentTypeName(section.contentType),
			isActive: true,
			order: index + 1
		}));

	const draft = draftOrders.map((section) => ({
		id: section.id,
		name: getContentTypeName(section.contentType),
		isActive: false
	}));

	return [...live, ...draft];
}
